import {QuizConfig} from '@/global/types/quiz';
import quiz from '@/quiz/equipment'

const equipment: QuizConfig = {
    options: quiz.options,
    types: quiz.types,
    pages: [],
    components: {}
}

export default equipment;